'use client';
import { ArticleSection } from '..';
import { NoticeProps } from './types';

export const Notice = (props: NoticeProps) => <ArticleSection {...props} />;
